import { ref, watch, onUnmounted } from 'vue';

export function useInboxGroups(accountId, userId) {
  const groups = ref([]);
  const canManage = ref(false);
  const error = ref('');
  const busy = ref(false);
  let generation = 0;
  let request = 0;
  // The dashboard configures authentication on window.axios, not raw Axios.
  const url = id => `/api/v1/accounts/${id}/inbox_groups`;
  async function refresh() {
    const id = accountId.value;
    const version = generation;
    const serial = ++request;
    if (!id) return;
    try {
      const { data } = await window.axios.get(url(id));
      if (version !== generation || serial !== request) return;
      groups.value = data.groups;
      canManage.value = data.can_manage;
      error.value = '';
    } catch {
      if (version === generation && serial === request) {
        error.value = '频道列表加载失败，请重试。';
      }
    }
  }
  async function mutate(method, path, data) {
    if (busy.value || !canManage.value) return false;
    const version = generation;
    busy.value = true;
    error.value = '';
    try {
      await window.axios({ method, url: `${url(accountId.value)}${path}`, data });
      if (version !== generation) return false;
      await refresh();
      return !error.value;
    } catch (e) {
      if (version === generation) {
        error.value = e.response?.data?.error || '操作失败，请刷新后重试。';
      }
      return false;
    } finally {
      if (version === generation) busy.value = false;
    }
  }
  watch([accountId, userId], () => {
    generation += 1;
    groups.value = [];
    canManage.value = false;
    busy.value = false;
    error.value = '';
    refresh();
  }, { immediate: true });
  const focus = () => { if (!busy.value) refresh(); };
  window.addEventListener('focus', focus);
  const timer = window.setInterval(() => {
    if (!document.hidden) focus();
  }, 30000);
  onUnmounted(() => {
    generation += 1;
    window.removeEventListener('focus', focus);
    window.clearInterval(timer);
  });
  return { groups, canManage, error, busy, refresh, mutate };
}
